// extracted by mini-css-extract-plugin
export default {"imageContainer":"NftEditionsTableRow_imageContainer__sp54K","profileLink":"NftEditionsTableRow_profileLink__vmrLu"};